module.exports = __webpack_public_path__ + "static/media/vital-on.9e925406.svg";